export function isScheduleValid(schedule) {
  return (
    schedule &&
    validateDate(schedule.startDate) &&
    validateDate(schedule.endDate) &&
    validateDate(schedule.startTime) &&
    validateDate(schedule.endTime) &&
    schedule.repeatWeekDays
  );
}

function validateDate(date) {
  try {
    if (date) {
      if (typeof date == "object") date = date.toISOString();
      const regex = /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i;
      return regex.test(date);
    }
  } catch (ex) {
    console.log(ex);
  }

  return false;
}

export function objectifySchedule(schedule) {
  const copy = { ...schedule };
  copy.startDate = convertToDate(copy.startDate);
  copy.endDate = convertToDate(copy.endDate);
  copy.startTime = convertToDate(copy.startTime);
  copy.endTime = convertToDate(copy.endTime);
  return copy;
}

function convertToDate(dateStr) {
  if (dateStr) {
    return new Date(dateStr);
  }

  return null;
}

export default { isScheduleValid, objectifySchedule };
